import * as React from 'react';
import { ApolloQueryResult, useQuery } from '@apollo/client';
import { isAccess } from '@css-xp/base';
import BillingAdmins from '@css-xp/base/billing-admin/src/billing-admins';
import {
  CommerceAddress,
  FetchBillingAdminsForTransactionAccountQuery,
  FetchBillingAdminsForTransactionAccountQueryVariables,
} from '@css-xp/graphtypes/src/generated-types-new';
import { Permissions } from '@atlassian/cssxp-typescommon';
import { fetchBillingAdminsForTransactionAccount } from './queries/fetch-billing-admins-for-transaction-account';

export interface Props {
  id: string;
  label: string;
  entityName: string;
  addBillingAdminsSidebarType: string;
  transactionAccountId: string;
  invoiceGroupId: string | undefined;
  billToAddress?: CommerceAddress | null;
  onComplete: () => Promise<ApolloQueryResult<unknown>>;
  transactionAccountNumber?: string;
  validDomains?: (string | null | undefined)[];
  isPartnerAccount?: boolean;
}

const BillingAdminsTab = (props: Props) => {
  const {
    id,
    entityName,
    addBillingAdminsSidebarType,
    transactionAccountId,
    invoiceGroupId,
    billToAddress,
    onComplete,
    transactionAccountNumber,
    validDomains,
    isPartnerAccount,
  } = props;
  const { data, loading } = useQuery<
    FetchBillingAdminsForTransactionAccountQuery,
    FetchBillingAdminsForTransactionAccountQueryVariables
  >(fetchBillingAdminsForTransactionAccount, {
    variables: { id },
    displayName: `fetch${entityName}BillingContacts`,
    notifyOnNetworkStatusChange: true,
    nextFetchPolicy: 'cache-first',
  });
  const resultSetSize = 0;
  const billingAdminConnection = data?.transactionAccount?.billingAdmins;
  const billingAdmins = billingAdminConnection?.edges || [];
  const totalHits = billingAdminConnection?.totalCount || 0;
  const billingAdminsLength = billingAdmins?.length || 0;
  const canRemoveBillingAdmin = isAccess(Permissions.BILLING_ADMIN_MANAGE);

  return (
    <div>
      <BillingAdmins
        billingAdmins={billingAdmins.map((billingAdmin) => ({
          fullName: billingAdmin?.node.fullName,
          email: billingAdmin?.node.email,
        }))}
        total={totalHits}
        loading={loading}
        addBillingAdminsSidebarType={addBillingAdminsSidebarType}
        transactionAccountId={transactionAccountId}
        invoiceGroupId={invoiceGroupId}
        billToAddress={billToAddress}
        onComplete={onComplete}
        transactionAccountNumber={transactionAccountNumber}
        validDomains={validDomains}
        isPartnerAccount={isPartnerAccount}
        isRemoveDisabled={!canRemoveBillingAdmin}
      />
    </div>
  );
};

export default BillingAdminsTab;
